import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Modal } from "@themesberg/react-bootstrap";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const MyModal = ({ show, handleClose, id, isEditing, isTable }) => {
    const location = useLocation();
    const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "file" ? files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        const submitData = new FormData();
        for (const key in formData) {
            submitData.append(key, formData[key]);
        }

        const dataObj = {};
        submitData.forEach((value, key) => {
            dataObj[key] = value;
        });

        let apiUrl = `${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/provider`;
        
        if (location.pathname.includes("/pwa-b2b/security-provider/")) {
            const id = location.pathname.split("/")[3];
            apiUrl = `${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/layanan`;
            dataObj["provider_id"] = id;
            submitData.append("provider_id", id);
        } else if (location.pathname.includes("/pwa-b2b/section")) {
            if (location.pathname.endsWith("sub-section")) {
                const id = location.pathname.split("/")[3];
                apiUrl = `${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/subsection`;
                dataObj["section_id"] = id;
                submitData.append("section_id", id);
            } else {
                const id = location.pathname.split("/")[3];
                apiUrl = `${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/product`;
                dataObj["section_id"] = id;
                submitData.append("section_id", id);
            }
        } else if (location.pathname === "/pwa-b2b/security-provider") {
            apiUrl = apiUrl
        } else {
            const id = location.pathname.split("/")[3];
            apiUrl = `${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/section`;
            dataObj["layanan_id"] = id;
            submitData.append("layanan_id", id);
        }

        try {
            if (isEditing) {
                await axios
                    .put(`${apiUrl}/${id}`, dataObj)
                    .then((response) => {
                        if (response.data.status === true) {
                            handleClose();
                            toast.success("Data Berhasil di Simpan");
                        } else if (response.data.status === false) {
                            handleClose();
                            toast.error(response.data.message)
                        }
                    }).catch((error) => {
                        toast.error(error);
                    });
            } else {
                await axios.post(apiUrl, submitData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((response) => {
                    console.log(response);
                    
                    if (response.data.status === true) {
                        handleClose();
                        toast.success("Data Berhasil di Tambahkan");
                    } else if (response.data.status === false) {
                        handleClose();
                        toast.error(response.data.message);
                    }
                }).catch((error) => {
                    toast.error(error);
                });
            }
        } catch (error) {
            toast.error("Terjadi kesalahan saat mengirim data : " + error);
        }
    };

    useEffect(() => {
        if (id) {
            const fetchDataById = async () => {
                try {
                    let response = null;
                    if (isTable === "provider") {
                        response = await axios.get(`${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/provider/${id}`);
                    } else if (isTable === "layanan") {
                        response = await axios.get(`${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/layanan/${id}/show`)
                    } else if (isTable === "section") {
                        response = await axios.get(`${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/section/${id}/show`)
                    } else if (isTable === "product") {
                        response = await axios.get(`${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/product/${id}/show`)
                    } else if (isTable === "subsection") {
                        response = await axios.get(`${process.env.REACT_APP_API_PWA_TNOS_DSBRD_URL}/pwa-revamp/subsection/${id}/show`)
                    }

                    if (response) {
                        setFormData(response.data.data);
                    }
                } catch (error) {
                    toast.error("Terjadi kesalahan saat mengambil data.");
                }
            };

            fetchDataById();
        }
    }, [id, isTable]);

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{isEditing ? "Edit Data" : "Tambah Data"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {location.pathname.includes("/pwa-b2b/security-provider/") ? (

                    <Form onSubmit={handleSubmit} method="POST">
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                                Nama Layanan
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                placeholder="Masukkan Nama Layanan"
                                value={formData.name || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </Form>
                ) : (location.pathname.includes("/pwa-b2b/layanan")) ? (
                    <Form onSubmit={handleSubmit} method="POST">
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label"> Nama </label>
                            <input type="text" className="form-control" id="name" name="name" placeholder="Masukkan Nama" value={formData.name || ""} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="have_sub_section" className="form-label"> Punya Sub Menu </label>
                            <Form.Select value={formData.have_sub_section || ""} name="have_sub_section" id="have_sub_section" onChange={handleChange}>
                                <option value="">- Pilih -</option>
                                <option value="0">Tidak</option>
                                <option value="1">Ya</option>
                            </Form.Select>
                        </div>
                    </Form>
                ) : (location.pathname.includes("/pwa-b2b/section")) ? (
                    <>
                        {location.pathname.endsWith("sub-section") ? (
                            <>
                                <Form onSubmit={handleSubmit} method="POST">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label"> Nama </label>
                                        <input type="text" className="form-control" id="name" name="name" placeholder="Masukkan Nama" value={formData.name || ""} onChange={handleChange} />
                                    </div>
                                </Form>
                            </>
                        ) : (
                            <>
                                <Form onSubmit={handleSubmit} method="POST">
                                    <div className="mb-3">
                                        <label htmlFor="column" className="form-label"> Kolom </label>
                                        <input type="text" className="form-control" id="column" name="column" placeholder="Masukkan Nama Kolom" value={formData.column || ""} onChange={handleChange} />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="harga" className="form-label"> Harga </label>
                                        <input type="number" className="form-control" id="harga" name="harga" placeholder="Masukkan Harga" value={formData.harga || ""} onChange={handleChange} />
                                    </div>
                                </Form>
                            </>
                        )}
                    </>
                ) : (
                    <Form onSubmit={handleSubmit} method="POST">
                        <div className="mb-3">
                            <label htmlFor="name_sc" className="form-label">
                                Nama Security Provider
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name_sc"
                                name="name_sc"
                                placeholder="Masukkan Nama Security Provider"
                                value={formData.name_sc || ""}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="name_pt" className="form-label">
                                Nama PT
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name_pt"
                                name="name_pt"
                                placeholder="Masukkan Nama PT"
                                value={formData.name_pt || ""}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="image" className="form-label">
                                Logo Gambar
                            </label>
                            <input
                                type="file"
                                className="form-control"
                                id="image"
                                name="image"
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="description" className="form-label">
                                Deskripsi
                            </label>
                            <textarea
                                name="description"
                                className="form-control"
                                id="description"
                                placeholder="Masukkan Deskripsi"
                                rows={5}
                                value={formData.description || ""}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button type="reset" size="sm" variant="danger" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} /> Batal
                </Button>
                <Button type="submit" size="sm" variant="success" onClick={handleSubmit}>
                    <FontAwesomeIcon icon={faSave} style={{ marginRight: '5px' }} /> Simpan
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MyModal;
